module.exports = __webpack_public_path__ + "static/media/increase_revenue_illustration.594a2c00.svg";